import React, { FC, useEffect } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { setTitle } from '../../../components/Header/model';
import { $error, loadExportTasksPage, resetAllStates, startExportTasksAutoUpdate, stopExportTasksAutoUpdate } from './model';
import { useUnit } from 'effector-react';
import { getListBoardForPageFx } from '../../model/board';
import { $selectWorkspace } from '../../model/workspace';
import { DynamicObjectExportForm } from './DynamicObjectExportForm';
import { DynamicObjectExportTaskList } from './DynamicObjectExportTaskList';

export const DynamicObjectExportPage: FC = () => {
  const [
    errorMessage,
    workspace,
  ] = useUnit([
    $error,
    $selectWorkspace,
  ]);

  useEffect(() => {
    setTitle('Отчет по обороту и выручке');
  }, []);

  useEffect(() => {
    if (!workspace) return;
    getListBoardForPageFx({
      filter: {
        limit: 1000,
        offset: 0,
        workspace,
      },
    });
  }, [workspace]);

  useEffect(() => {
    loadExportTasksPage();
  }, []);

  useEffect(() => {
    startExportTasksAutoUpdate();
    return () => {
      stopExportTasksAutoUpdate();
      resetAllStates();
    };
  }, []);

  return (
    <Box display="flex" flexDirection="column" gap={3} p={3} width="100%">
      <Box height={20}></Box>

      {errorMessage && (
        <Typography color="error" variant="body2">
          {errorMessage}
        </Typography>
      )}

      <DynamicObjectExportForm />
      <DynamicObjectExportTaskList />
    </Box>
  );
};

